import { render, staticRenderFns } from "./shutDown.vue?vue&type=template&id=1bd6dad3&scoped=true&"
import script from "./shutDown.vue?vue&type=script&lang=ts&"
export * from "./shutDown.vue?vue&type=script&lang=ts&"
import style0 from "./shutDown.vue?vue&type=style&index=0&id=1bd6dad3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd6dad3",
  null
  
)

export default component.exports